import React from "react";
import { pageProps } from "../../helpers/pageProps";

export default function NewFeature({
  children,
  alternative = null,
  showDisabled = false,
}) {
  const { showNewFeatures } = pageProps;

  if (showNewFeatures) {
    return (
      <div className="" style={{ outline: "1px solid red" }}>
        {children}
      </div>
    );
  }

  if (alternative) {
    return alternative;
  }

  // if (showDisabled) {
  //   return (
  //     <div className="position-relative h-100 opacity-25">
  //       <div
  //         className="position-absolute top-0 start-0 w-100 h-100 z-3"
  //         title="Feature coming soon"
  //       ></div>
  //       {children}
  //     </div>
  //   );
  // }

  return null;
}
